/*
 * tutor/registry — component-name → React component map (registry v1).
 * Unknown names fall back to TextBubble (client mirror of hard rule 2).
 */
import { TutorMcqCard, TutorFlashCard, RapidAnswer, StructuredAnswer } from './components/answer';
import { HintPanel, ConceptCard, WorkedExampleStepper } from './components/scaffold';
import { FeedbackCard, ActionChips, MisconceptionCallout } from './components/feedback';
import { TutorProgressBar, TextBubble, SessionSummary } from './components/meta';

export const REGISTRY = {
  mcq_card: TutorMcqCard,
  flash_card: TutorFlashCard,
  rapid_answer: RapidAnswer,
  structured_answer: StructuredAnswer,
  hint_panel: HintPanel,
  feedback_card: FeedbackCard,
  action_chips: ActionChips,
  progress_bar: TutorProgressBar,
  text_bubble: TextBubble,
  concept_card: ConceptCard,
  worked_example_stepper: WorkedExampleStepper,
  misconception_callout: MisconceptionCallout,
  session_summary: SessionSummary,
};

export const resolve = (name) => REGISTRY[name] || TextBubble;
